import React, { ReactNode } from "react";
import { Card, Row, Col } from "react-bootstrap";
import ListIcon from '@mui/icons-material/List';
import CreateIcon from '@mui/icons-material/Create';
import styled from "styled-components";
import MenuItemCard from "../../organisms/MenuItemCard";
import { useUsuarioActual } from "../../../services/authServicios";
import { puedeAccederRuta } from "../../../services/rolAutorizacion";
import {
  RUTA_RESERVAS_GUARDERIA_CREAR,
  RUTA_RESERVAS_GUARDERIA_LISTAR,
} from "../../../services/rutas";

function CardSection() {
  const { data: usuario } = useUsuarioActual();

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-12 col-lg-8 col-xxl-6">
        <Card>
          <StyledCardHeader className="mt-2">
            <TitleContainer>
              <CardTitle fontSize={24}>Acciones en Reservas de Guardería</CardTitle>
            </TitleContainer>
          </StyledCardHeader>
          <Card.Body>
            <Row className="justify-content-center mb-2 p-3">
              {puedeAccederRuta(usuario, RUTA_RESERVAS_GUARDERIA_CREAR) && (
                <CardCol>
                  <MenuItemCard
                    Icono={CreateIcon}
                    ruta={RUTA_RESERVAS_GUARDERIA_CREAR}
                    titulo="Crear"
                    descripcion="Agenda una nueva reserva"
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_RESERVAS_GUARDERIA_LISTAR) && (
                <CardCol>
                  <MenuItemCard
                    Icono={ListIcon}
                    ruta={RUTA_RESERVAS_GUARDERIA_LISTAR}
                    titulo="Listar"
                    descripcion="Visualiza reservas existentes"
                  />
                </CardCol>
              )}
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

const CardCol = ({ children }: { children: ReactNode }) => {
  return (
    <Col xs={12} md={6} sm={6} className="mb-2">
      {children}
    </Col>
  );
};

const CardTitle = styled("h4")<{ fontSize?: number }>`
  font-size: ${(props) => (props.fontSize ? props.fontSize + "px" : "20px")};
  font-weight: 500;
  color: #454545;
  letter-spacing: 0.05em;
`;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background-color: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0px;
`;

const TitleContainer = styled("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default CardSection;
